import { ContentState } from "draft-js";
import { I18n } from "@assets/strings";
import React, { useState } from "react";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import congratIcon from "@assets/images/congrat_icon.png";
import { Path } from "@core/routing/path";
import { useServices } from "@core/servicesContext";
import { Post } from "@domain/post/post";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { Primary } from "@ui/components/containers/primary";
import { RichTextInput } from "@ui/components/inputs/draft/richTextInput";
import { Toggle } from "@ui/components/inputs/toggle";
import { row } from "@ui/components/layout";
import { ClosableModal } from "@ui/modals/closableModal";
import { createToast } from "@ui/toasts/utils";
interface CongralutationModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
	canonicalLink?: string;
	applicationId?: string;
	initialPost?: Post;
}

export const CongralutationModal: React.FC<CongralutationModalProps> = ({
	canonicalLink,
	applicationId,
	close,
	initialPost,
	...htmlProps
}) => {
	const history = useHistory();
	const { applicationService } = useServices();
	const [isTogled, setToggle] = useState(true);
	const [shareMessage, setShareMessage] = useState(
		initialPost ? initialPost.text : ContentState.createFromText(I18n.t("vote.share.my-profile.message"))
	);
	const [loading, setLoading] = useState(false);
	//const clearedShareMessage = shareMessage.getPlainText() ? shareMessage : undefined;

	if (!applicationService) {
		return null;
	}

	const shareApplication = async (): Promise<void> => {
		if (!applicationId) {
			return;
		}

		setLoading(true);
		try {
			await applicationService.shareApplication(applicationId, shareMessage.getPlainText());
			createToast(I18n.t("success"), I18n.t("application.succes.share_video.toast"), "success");
			close();
			history.push(Path.Root);

			//return fetchedShareApplication;
		} catch (e) {
			console.error(e);
			createToast(I18n.t("error"), I18n.t("auth.error.default"), "error");
			setLoading(false);
			//close()
		} finally {
			setLoading(false);
		}
	};

	return (
		<Container close={close} {...htmlProps}>
			<ContainerLabel>
				<img src={congratIcon} width="191px" height="175px" />
				<Primary>
					<CongralutationText>
						<b>{I18n.t("profile.application.popin-success.label")}</b>
					</CongralutationText>
				</Primary>
			</ContainerLabel>
			<Info>
				<b>{I18n.t("profile.application.popin-success.message")}</b>.{" "}
			</Info>
			{/* <ShareProfileInfo>{I18n.t("profile.application.popin-success.share-profile.label")} </ShareProfileInfo>
			<ContainerIcon>
				{currentProfile ? (
					<>
						<Tooltipable
							text={I18n.t("application.success.share_social.label", { name: "Facebook" })}
							offset={-3}
							dark={true}
						>
							<SocialMediaIcon
								onClick={() =>
									facebookService.openShareDialog(
										`${Config.APP_BASE_URL}${Path.Profile(currentProfile)}`,
										I18n.t("vote.share.my-profile.message")
									)
								}
							>
								<FacebookIcon />
							</SocialMediaIcon>
						</Tooltipable>

						<Tooltipable
							text={I18n.t("application.success.share_social.label", { name: "Twitter" })}
							offset={-3}
							dark={true}
						>
							<SocialMediaIcon
								onClick={() =>
									twitterService.openShareDialog(
										`${Config.APP_BASE_URL}${Path.Profile(currentProfile)}`,
										I18n.t("vote.share.my-profile.message")
									)
								}
							>
								<TwitterIcon />
							</SocialMediaIcon>
						</Tooltipable>

						<Tooltipable
							text={I18n.t("application.success.share_social.label", { name: "LinkedIn" })}
							offset={-3}
							dark={true}
						>
							<SocialMediaIcon
								onClick={() =>
									linkedinService.openShareDialog(
										`${Config.APP_BASE_URL}${Path.Profile(currentProfile)}`,
										I18n.t("vote.share.my-profile.message")
									)
								}
							>
								<LinkedInIcon />
							</SocialMediaIcon>
						</Tooltipable>

						<Tooltipable
							text={I18n.t("application.success.share_social.label", { name: "WhatsApp" })}
							offset={-3}
							dark={true}
						>
							<SocialMediaIcon
								onClick={() =>
									whatsappService.openShareDialog(
										`${Config.APP_BASE_URL}${Path.Profile(currentProfile)}` +
											"" +
											I18n.t("vote.share.my-profile.message")
									)
								}
							>
								<WhatSappIcon />
							</SocialMediaIcon>
						</Tooltipable>

						<Tooltipable text={I18n.t("application.succes.copy_link.label")} offset={-3} dark={true}>
							<SocialMediaIcon
								onClick={() => {
									navigator.clipboard.writeText(canonicalLink ?? window.location.href);
									createToast(I18n.t("success"), I18n.t("profile.card.invite.action.copied_link"), "success");
								}}
							>
								<ClipboardIcon />
							</SocialMediaIcon>
						</Tooltipable>
					</>
				) : (
					<></>
				)}
			</ContainerIcon> */}
			<ContainerToogle>
				<Toggle toggled={isTogled} onChange={() => setToggle(!isTogled)}></Toggle>
				<StyeledGeneratePostText>{I18n.t("application.succes.share_video.title")}</StyeledGeneratePostText>
			</ContainerToogle>
			{isTogled && (
				<>
					<StyledInput
						mentionsEnabled
						richStyleEnabled={false}
						placeholder={I18n.t("post.input.placeholder")}
						value={shareMessage}
						onChange={(v) => setShareMessage(v)}
					/>
					<LoadingButton loading={loading} disabled={!isTogled} onClick={shareApplication}>
						{I18n.t("application.succes.share_video.button")}
					</LoadingButton>
				</>
			)}
		</Container>
	);
};

const Container = styled(ClosableModal)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

// const ContainerIcon = styled.div`
// 	display: flex;
// 	justify-content: center;
// 	align-items: center;
// 	margin: 20px;
// `;

const ContainerToogle = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
	margin-bottom: 40px;
`;

// const SocialMediaIcon = styled.div`
// 	margin-left: 20px;
// 	cursor: pointer;
// `;

const ContainerLabel = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const Info = styled.div`
	${row(16, "flex-start", "baseline")};
	${({ theme }) => theme.textStyles.description};
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 29px;
	text-align: center;

	color: #000000;
`;

// const ShareProfileInfo = styled.div`
// 	${row(16, "flex-start", "baseline")};
// 	${({ theme }) => theme.textStyles.description};
// 	font-weight: 500;
// 	font-size: 16px;
// 	line-height: 29px;
// 	text-align: center;
// 	color: #206af8;
// 	line-height: 25px;
// 	margin-top: 20px;
// `;

const CongralutationText = styled.div`
	font-style: normal;
	font-size: 24px;
	margin-top: 16px;
`;
const StyeledGeneratePostText = styled.div`
	font-style: normal;
	font-size: 12px;
	margin-left: 6px;
`;

const StyledInput = styled(RichTextInput)`
	width: 100%;
	height: 100px;
	border: 1px solid ${({ theme }) => theme.colors.lightergray};
	border-radius: 16px;
	flex: 1;
	margin-bottom: 30px;

	.public-DraftEditor-content,
	.public-DraftEditorPlaceholder-root {
		padding: 10px 12px 9px;
		font-size: 0.8125rem;
	}
	.public-DraftEditorPlaceholder-root {
		font-weight: 400;
		opacity: 0.8;
	}
`;
